import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Chip from './Chip'
import './PersonCard.css'

const PersonCard = ({ person, onSeeCompatibility, className = '' }) => {
  const { t } = useTranslation()
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0)
  
  if (!person) return null

  const photos = person.photos || []
  const currentPhoto = photos[currentPhotoIndex] || null

  const handlePrevPhoto = () => {
    if (currentPhotoIndex > 0) {
      setCurrentPhotoIndex(prev => prev - 1)
    }
  }

  const handleNextPhoto = () => {
    if (currentPhotoIndex < photos.length - 1) {
      setCurrentPhotoIndex(prev => prev + 1)
    }
  }

  return (
    <div className={`person-card ${className}`}>
      <div className="card-photo">
        {photos.length > 1 && (
          <>
            {currentPhotoIndex > 0 && (
              <button
                type="button"
                className="card-photo-nav-btn card-photo-nav-btn-left"
                onClick={handlePrevPhoto}
                aria-label={t('common.previousPhoto')}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
            )}
            {currentPhotoIndex < photos.length - 1 && (
              <button
                type="button"
                className="card-photo-nav-btn card-photo-nav-btn-right"
                onClick={handleNextPhoto}
                aria-label={t('common.nextPhoto')}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            )}
          </>
        )}
        {currentPhoto ? (
          <>
            <img src={currentPhoto} alt={person.name} />
            {photos.length > 1 && (
              <div className="photo-indicators">
                {photos.map((_, index) => (
                  <span
                    key={index}
                    className={`photo-indicator ${index === currentPhotoIndex ? 'active' : ''}`}
                  />
                ))}
              </div>
            )}
          </>
        ) : (
          <div className="photo-placeholder">{t('common.noPhoto')}</div>
        )}
      </div>
      
      <div className="card-content">
        <div className="card-header">
          <div className="card-name-row">
            <h3 className="card-name">{person.name}, {person.age}</h3>
            <span 
              className="compatibility-label"
              style={{ 
                color: '#000000', 
                backgroundColor: person.compatibilityBgColor || '#E5FED2' 
              }}
            >
              {person.compatibilityLabel || person.compatibility}
            </span>
          </div>
          <p className="card-zodiac">
            {person.zodiac} {person.zodiacSymbol}
          </p>
        </div>

        {person.interests && person.interests.length > 0 && (
          <div className="card-interests">
            {person.interests.slice(0, 4).map((interest, index) => {
              const tr = t('onboarding.interestsItems.' + interest)
              const label = tr === 'onboarding.interestsItems.' + interest ? interest : tr
              return (
                <Chip key={index} active={false}>
                  {label}
                </Chip>
              )
            })}
          </div>
        )}

        <button className="card-cta" onClick={onSeeCompatibility}>
          {t('card.seeCompatibility')}
        </button>
      </div>
    </div>
  )
}

export default PersonCard

